import React, { useState } from 'react';
import { acceptedImageFormats } from 'app/pages/library/components/Constants';
import DragAndDrop from 'lib/components/inputs/DragAndDrop';
import { ISelectedFile } from 'app/pages/conversations/forms/sms';
import { Flex } from 'lib/components/styles/layout';
import { useCreateImageMutation } from 'lib/api/image/useCreateImageMutation';
import { useUploadImage } from 'lib/hooks/useUploadImage';
import { useAuth } from 'lib/context';
import { prepareImageNameForUpload } from 'lib/utils/files';

type ImageTabProps = {
  onSelect: (item: ISelectedFile, itemType: string) => void;
  handleModalClose: () => void;
};

const ImageTab = ({ onSelect, handleModalClose }: ImageTabProps) => {
  const { userData } = useAuth();
  const [uploadProgress, setUploadProgress] = useState(0);
  const { uploadImage } = useUploadImage();
  const { mutateAsync: createImage, isLoading: isCreating } =
    useCreateImageMutation();

  const handleSelectedFile = async (e: InputEvent) => {
    e.stopPropagation();
    e.preventDefault();

    const target = e.dataTransfer || (e.target as HTMLInputElement);
    if (target && target.files && target.files.length) {
      const file = target.files[0];
      // upload to aws
      const url = await uploadImage(file, userData.id, setUploadProgress);
      // create image in db
      const imageData = await createImage({
        fileName: prepareImageNameForUpload(file.name),
        mimeType: file.type,
      });

      onSelect({ url, imageId: imageData?.id || 0 }, 'image');
      handleModalClose();
    }
  };

  const isDisabled = isCreating || (!!uploadProgress && uploadProgress > 0);

  return (
    <Flex margin='40px 0 0 0' style={{ position: 'relative' }} width='100%'>
      <DragAndDrop
        height={445}
        width={'100%'}
        showIcon={false}
        button={true}
        isMultiple={false}
        text='Drag and drop an image here'
        onDrop={handleSelectedFile}
        textStyle={{
          marginBottom: '0',
          width: '100%',
          fontWeight: 400,
        }}
        variant='white'
        showAddIcon={false}
        accept={acceptedImageFormats.join(', ')}
        disabled={isDisabled}
      />
    </Flex>
  );
};

export default ImageTab;
